import { QueryCondition } from '@edulead/models';
import General from './GeneralUtils';

/**
 * EDU-53: the People directory no longer offers the "Last Seen" filter. Every search (and the
 * export built from it) is restricted to contacts seen within the past 6 months instead, without
 * the user having to choose. Buying Groups and the v3 API are not affected: they pass their own
 * query and never go through these helpers.
 */
const LAST_SEEN_FIELD = 'lastSeen';

export const DEFAULT_LAST_SEEN_RULE: QueryCondition = {
  field: LAST_SEEN_FIELD,
  operator: 'equals',
  value: 'LAST_SEEN_0_6',
};

/**
 * Removes any `lastSeen` rule from an encoded `q` so the query editor never shows one
 * (old URLs and saved searches still carry it). Returns `q` untouched when there is nothing to
 * strip or it cannot be decoded.
 */
export function stripLastSeenFromQ(q: string): string {
  const decoded = General.decode(q);
  if (!decoded || !Array.isArray(decoded.rules)) return q;
  if (!decoded.rules.some((rule: any) => rule?.field === LAST_SEEN_FIELD)) return q;
  const rules = decoded.rules.filter((rule: any) => rule?.field !== LAST_SEEN_FIELD);
  return General.encode({ ...decoded, rules }) ?? q;
}

/** Appends the 6-month `lastSeen` rule unless the query already restricts `lastSeen`. */
export function withDefaultLastSeen(query: QueryCondition[]): QueryCondition[] {
  if (query.some(rule => rule.field === LAST_SEEN_FIELD)) return query;
  return [...query, DEFAULT_LAST_SEEN_RULE];
}
